import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';
import { serializedModelNameEquals } from './utils';

export const MODELS = [
  'anthropic.claude-sonnet-4-5-20250929-v1:0',
  'anthropic.claude-opus-4-20250514-v1:0',
  'anthropic.claude-sonnet-4-20250514-v1:0',
  'anthropic.claude-3-7-sonnet-20250219-v1:0',
  'anthropic.claude-3-5-haiku-20241022-v1:0',
  'anthropic.claude-3-5-sonnet-20241022-v2:0',
  'anthropic.claude-3-5-sonnet-20240620-v1:0',
  'anthropic.claude-3-opus-20240229-v1:0',
  'anthropic.claude-3-sonnet-20240229-v1:0',
  'anthropic.claude-3-haiku-20240307-v1:0',
  'amazon.titan-tg1-large',
  'amazon.titan-text-lite-v1',
  'amazon.titan-text-express-v1',
  'ai21.j2-grande-instruct',
  'ai21.j2-jumbo-instruct',
  'ai21.j2-mid',
  'ai21.j2-mid-v1',
  'ai21.j2-ultra',
  'ai21.j2-ultra-v1',
  'cohere.command-text-v14',
  'cohere.command-light-text-v14',
  'meta.llama2-13b-chat-v1',
  'meta.llama2-70b-chat-v1',
  'meta.llama2-13b-v1',
  'meta.llama2-70b-v1',
].map((value) => ({ label: value, value }));

export const DEFAULT_MODEL: string =
  'anthropic.claude-sonnet-4-5-20250929-v1:0';

export function useBedrockChatModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs ?? {};
  const model = kwargs.model_id || kwargs.model || DEFAULT_MODEL;

  if (props.variant === 'line') {
    return {
      model,
      provider: id,
    };
  }
  return null;
}

export function inferBedrockChatManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    !(
      serializedModelNameEquals(serializedModel, 'ChatBedrock') ||
      serializedModelNameEquals(serializedModel, 'BedrockChat')
    ) ||
    (params?.ls_provider &&
      params?.ls_provider !== 'bedrock' &&
      params?.ls_provider !== 'amazon_bedrock') ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'bedrock', 'ChatBedrock'],
    kwargs: {
      ...(params?.ls_model_name !== undefined && {
        model_id: params.ls_model_name,
      }),
      ...(params?.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params?.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      aws_access_key_id: {
        lc: 1,
        type: 'secret',
        id: ['AWS_ACCESS_KEY_ID'],
      },
      aws_secret_access_key: {
        lc: 1,
        type: 'secret',
        id: ['AWS_SECRET_ACCESS_KEY'],
      },
      aws_session_token: {
        lc: 1,
        type: 'secret',
        id: ['AWS_SESSION_TOKEN'],
      },
      credentials: undefined,
      max_retries: undefined,
      signal: undefined,
      llm_type: undefined,
      endpoint_host: undefined,
      stop_sequences: undefined,
      trace: undefined,
      supports_tool_choice_values: undefined,
    },
  };
}
